<template>
    <transition name="slide">
        <div class="bg-surface-secondary w-100">
            <header class="bg-surface-primary border-bottom">
                <div class="container-fluid py-4">
                    <div class="row align-items-center">
                        <div class="col">
                            <div class="d-flex align-items-center gap-4">
                                <div>
                                    <button type="button" class="btn-close text-xs" @click="$router.go(-1)"></button>
                                </div>
                                <div class="vr opacity-20 my-1"></div>
                                <h1 class="h4 ls-tight">Actualizar ruta</h1>
                            </div>
                        </div>
                        <div class="col-auto">
                            <div class="hstack gap-2 justify-content-end">
                                <button @click="UPDATE()" type="button" class="btn btn-h btn-success px-3">
                                    <div class="spinner-border spinner-border-sm" role="status" v-if="count == 1">
                                        <span class="sr-only">Loading...</span>
                                    </div>
                                    <span v-else>Guardar cambios</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
            <main class="py-6 bg-surface-secondary">
                <div class="container-fluid max-w-screen-md vstack gap-3">
                    <div>
                        <small class="input-title">Código</small>
                        <input type="text" class="form-control form-control-sm" v-model="data.code" :class="errors.code ? 'is-invalid' : ''">
                        <small class="invalid-feedback" v-for="(error, index) in errors.code" :key="index">{{ error }}</small>
                    </div>
                    <div>
                        <small class="input-title">Nombre</small>
                        <input type="text" class="form-control form-control-sm" v-model="data.name" :class="errors.name ? 'is-invalid' : ''">
                        <small class="invalid-feedback" v-for="(error, index) in errors.name" :key="index">{{ error }}</small>
                    </div>
                    <div>
                        <small class="input-title">Entregar en: </small>
                        <v-autocomplete v-model="data.deliver_to"
                            :items="delivers"
                            hide-details
                            @change="FRESH"
                            class="form-control form-control-sm"
                            :class="errors.branch ? 'is-invalid' : ''">
                        </v-autocomplete>
                        <small class="invalid-feedback" v-for="(error, index) in errors.deliver_to" :key="index">{{ error }}</small>
                    </div>
                    <div v-if="data.deliver_to == 1">
                        <small class="input-title">Sucursal: </small>
                        <v-autocomplete v-model="data.branch_office_id"
                            item-value="id"
                            item-text="name"
                            :items="branch_offices"
                            hide-details
                            class="form-control form-control-sm"
                            :class="errors.branch_office_id ? 'is-invalid' : ''">
                        </v-autocomplete>
                        <small class="invalid-feedback" v-for="(error, index) in errors.branch_office_id" :key="index">{{ error }}</small>
                    </div>
                    <div v-if="data.deliver_to == 0">
                        <div class="row">
                            <div class="col-lg-4 pl-0 pr-0 pr-lg-2">
                                <small class="input-title">País: </small>
                                <v-autocomplete v-model="country_id"
                                    :items="countries"
                                    item-text="name"
                                    item-value="id"
                                    hide-details
                                    @change="PROVINCES"
                                    class="form-control form-control-sm">
                                </v-autocomplete>
                            </div>
                            <div class="col-lg-4 pl-0 pr-0 pr-lg-2">
                                <small class="input-title">Provincia: </small>
                                <v-autocomplete v-model="province_id"
                                    :items="provinces"
                                    item-text="name"
                                    item-value="id"
                                    hide-details
                                    @change="CITIES"
                                    class="form-control form-control-sm">
                                </v-autocomplete>
                            </div>
                            <div class="col-lg-4 pl-0 pr-0">
                                <small class="input-title">Cuidad: </small>
                                <v-autocomplete v-model="city_id"
                                    :items="cities"
                                    item-text="name"
                                    item-value="id"
                                    hide-details
                                    @change="DISTRICTS"
                                    class="form-control form-control-sm">
                                </v-autocomplete>
                            </div>
                        </div>
                        <div>
                            <small class="input-title">Distritos a Agregar: </small>
                            <div class="input-group input-group-sm">
                                <v-autocomplete v-model="append_districts"
                                    :items="districts"
                                    item-text="name"
                                    item-value="id"
                                    hide-details
                                    small-chips
                                    multiple
                                    chips
                                    class="form-control form-control-sm textarea">
                                </v-autocomplete>
                                <div class="input-group-append">
                                    <button class="btn btn-primary px-3" :disabled="append_districts.length == 0" @click="APPEND_DISTRICTS()">Agregar</button>
                                </div>
                            </div>
                        </div>
                        <div>
                            <small class="input-title">Distritos: </small>
                            <v-autocomplete v-model="data.districts"
                                :items="get_districts"
                                item-text="name"
                                item-value="id"
                                hide-details
                                small-chips
                                multiple
                                chips
                                class="form-control form-control-sm textarea"
                            :class="errors.districts ? 'is-invalid' : ''">
                            </v-autocomplete>
                        <small class="invalid-feedback" v-for="(error, index) in errors.districts" :key="index">{{ error }}</small>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    </transition>
</template>
<script>
export default{
    data(){
        return{
            data: {
                districts: []
            },
            errors: {},
            count: 0,
            id: this.$route.params.id,
            delivers: [
                { value: 0, text: 'Dirección' },
                { value: 1, text: 'Sucursal' }
            ],
            countries: [],
            provinces: [],
            cities: [],
            districts: [],
            all_districts: [],
            branch_offices: [],
            country_id: '',
            province_id: '',
            city_id: '',
            append_districts: [],
            bk_districts: []
        }
    },
    created(){
        this.INIT()
        this.ALL_DISTRICTS()
    },
    computed:{
        get_districts: function(){
            let vue = this
            let data = []
            vue.bk_districts.forEach(element => {
                data.push(vue.all_districts.find(e => e.id == element))
            });
            return data
        }
    },
    methods: {
        FRESH: function(){
            let vue = this
            vue.country_id = ''
            vue.province_id = ''
            vue.city_id = ''
            vue.append_districts = []
            vue.bk_districts = []
            vue.data.districts = []
            vue.data.branch_office_id = ''
            vue.append_districts = []
            if(vue.data.deliver_to == 1){
                vue.BRANCH_OFFICES()
            }else{
                vue.COUNTRIES()
            }
        },
        BRANCH_OFFICES: function(){
            let vue = this
            axios({url: '/all/branch-offices', method: 'GET' })
            .then((resp) => {
                vue.branch_offices = resp.data
            })
        },
        ALL_DISTRICTS: function(){
            let vue = this
            axios({url: '/locations/districts', method: 'GET' })
            .then((resp) => {
                vue.all_districts = resp.data
            })
        },
        COUNTRIES: function(){
            let vue = this
            axios({url: '/locations/countries', method: 'GET' })
            .then((resp) => {
                vue.countries = resp.data
            })
            .finally((resp) => {
                if(vue.data.country_id){
                    vue.PROVINCES()
                }
            })
        },
        PROVINCES: function(){
            let vue = this
            axios({url: '/locations/provinces/'+ vue.country_id, method: 'GET' })
            .then((resp) => {
                vue.provinces = resp.data
            })
            .finally((resp) => {
                if(vue.data.province_id){
                    vue.CITIES()
                }
            })
        },
        CITIES: function(){
            let vue = this
            axios({url: '/locations/cities/'+ vue.province_id, method: 'GET' })
            .then((resp) => {
                vue.cities = resp.data
            })
            .finally((resp) => {
                if(vue.data.city_id){
                    vue.DISTRICTS()
                }
            })
        },
        DISTRICTS: function(){
            let vue = this
            axios({url: '/locations/districts/'+ vue.city_id, method: 'GET' })
            .then((resp) => {
                vue.districts = resp.data
            })
        },
        APPEND_DISTRICTS: function(){
            let vue = this
            vue.append_districts.forEach(element => {
                let index = vue.data.districts.findIndex(e => e == element)
                if(index == -1){
                    vue.data.districts.push(element)
                    vue.bk_districts.push(element)
                }
            })
            vue.append_districts = []
        },
        INIT: function () {
            let vue = this
            axios({ url: '/routes/' + vue.id, method: 'GET' })
                .then((resp) => {
                    vue.data = resp.data
                    vue.bk_districts = vue.data.districts
                    if(vue.data.deliver_to == 1){
                        vue.BRANCH_OFFICES()
                    }else{
                        vue.COUNTRIES()
                    }
                })
                .catch((err) => {
                   let message = err.response ? err.response.data.message : err.message
                        vue.$swal({ toast: true, icon: 'error', title: message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                })
                .finally((resp) => {
                    vue.loading = false
                })
        },
        UPDATE: function(){
            let vue = this
            vue.count++
            if(vue.count == 1){
                vue.errors = {}
                setTimeout(() => {
                    let form = {
                        code: vue.data.code,
                        name: vue.data.name,
                        deliver_to: vue.data.deliver_to,
                        branch_office_id: vue.data.branch_office_id,
                        districts: JSON.stringify(vue.data.districts),
                    }
                    axios({url: '/routes/' + vue.id, method: 'PUT', data: form })
                    .then((resp) => {
                        vue.$swal({ toast: true, icon: 'success', title: resp.data.message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                        vue.$router.push({ name: 'RouteIndex' })
                    })
                    .catch((err) => {
                        if(err.response.status !== 422){
                            let message = err.response ? err.response.data.message : err.message
                            vue.$swal({ toast: true, icon: 'error', title: message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                        } else {
                            vue.errors = err.response.data
                        }
                    })
                    .finally((resp)=>{
                        vue.count = 0
                    })
                }, 1000)
            }
        }
    },
    watch: {
        data: {
            handler(e) {
                if(e.country_id){
                    let vue = this
                    vue.COUNTRIES()
                }
            },
            deep: true
        }
    }
}
</script>